// src/config/api.js
// api.js — add /api to base
const API_URL = process.env.REACT_APP_API_URL || 'https://api.kaydsystems.com/api';

export const apiCall = async (endpoint, options = {}) => {
  const url = `${API_URL}${endpoint}`;
  
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const response = await fetch(url, { ...defaultOptions, ...options });
  return response;
};

export default API_URL;